import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "modal-title"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-title"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-cross fs-1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
    /*#__PURE__*/_createElementVNode("span", { class: "path2" })
  ])
], -1)
const _hoisted_8 = { class: "modal-body text-start" }
const _hoisted_9 = { class: "row mb-6 d-flex flex-column" }
const _hoisted_10 = {
  key: 0,
  class: "col-lg-8 fv-row mb-5"
}
const _hoisted_11 = {
  disabled: "",
  selected: "",
  value: "''"
}
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 1,
  class: "col-lg-8 fv-row mb-5"
}
const _hoisted_14 = {
  disabled: "",
  selected: "",
  value: 0
}
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 2,
  class: "col-lg-8 fv-row mb-5"
}
const _hoisted_17 = { class: "col-lg-8 fv-row mb-5" }
const _hoisted_18 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "col-lg-8 fv-row mb-5" }
const _hoisted_23 = { class: "modal-footer" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Close ", -1)
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "indicator-label" }
const _hoisted_27 = { class: "indicator-progress" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    tabindex: "-1",
    id: `kt_modal_${_ctx.index}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.editTreatiment)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_5, " Add Medical Treatment "))
            : (_openBlock(), _createElementBlock("h3", _hoisted_6, "Upload New Attachment")),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (!_ctx.editTreatiment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "horseId",
                    class: "form-select form-select-solid form-select-lg text-capitalize",
                    modelValue: _ctx.treatmentPayload.horseId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.treatmentPayload.horseId) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.translate('horse')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allHorsesList, (horse) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: horse.id,
                          value: horse.id
                        }, _toDisplayString(horse.nameEn), 9, _hoisted_12))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.editTreatiment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "treatmantId",
                    class: "form-select form-select-solid form-select-lg text-capitalize",
                    modelValue: _ctx.treatmentPayload.treatmentId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.treatmentPayload.treatmentId) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.translate('Select treatmant')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.treatmantLIst, (treatmant) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: treatmant.id,
                          value: treatmant.id
                        }, _toDisplayString(treatmant.nameEn), 9, _hoisted_15))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.editTreatiment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_Field, {
                    type: "date",
                    name: "treatmentDate",
                    class: "form-select form-select-solid form-select-lg",
                    modelValue: _ctx.treatmentPayload.treatmentDate,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.treatmentPayload.treatmentDate) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_Field, {
                as: "select",
                name: "documentTypeId",
                class: "form-select form-select-solid form-select-lg text-capitalize",
                modelValue: _ctx.treatmentPayload.docuemntTypeId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.treatmentPayload.docuemntTypeId) = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.translate('Select Document')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentsType, (document) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: document.id,
                      value: document.id
                    }, _toDisplayString(document.nameEn), 9, _hoisted_19))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_ErrorMessage, { name: "documentTypeId" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_Field, {
                type: "file",
                name: "attachments",
                class: "form-control form-control-lg form-control-solid",
                modelValue: _ctx.treatmentPayload.attachments,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.treatmentPayload.attachments) = $event)),
                multiple: ""
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("button", {
            type: "button",
            id: "kt_account_profile_details_submit",
            ref: "submitButton",
            class: "btn btn-primary",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitBtn && _ctx.submitBtn(...args))),
            disabled: _ctx.disabledSubmitButton()
          }, [
            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.translate('saveChanges')), 1),
            _createElementVNode("span", _hoisted_27, [
              _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
              _hoisted_28
            ])
          ], 8, _hoisted_25)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}